export const LOGIN = 'login'
export const LOGOUT = 'logout'
export const TOKEN = 'token'
export const QUERYHEADER = 'queryHeader'
export const GETSITEINFO = 'getSiteInfo'
